import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { AnnouncementCost, AnnouncementListResponse, AnnouncementResponse, CreateAnnouncementPayload, PublishAnnouncementPayload } from '../models/announcement';

export const onGetAnnouncementList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<AnnouncementListResponse>>('dashboard/actions/announcement', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetAnnouncementById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<AnnouncementResponse>>(`dashboard/actions/announcement/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCancelAnnouncement = async (id: string) => {
	try {
		const response = await axios.post(`dashboard/actions/announcement/${id}/cancel`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onPublishAnnouncement = async (id: string, payload: PublishAnnouncementPayload) => {
	try {
		const response = await axios.post(`dashboard/actions/announcement/${id}/publish`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendAnnouncementOtp = async () => {
	try {
		const response = await axios.post('dashboard/actions/announcement/publish/send-otp');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateAnnouncement = async (payload: CreateAnnouncementPayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/announcement`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
